import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

export interface MapPinConfig {
  latitude: number;
  longitude: number;
  locationName: string;
  markerIcon: string;
  maxRadiusMeters?: number;
}

export interface MapPinResult {
  latitude: number;
  longitude: number;
  locationName?: string;
}

@Injectable()
export class MapPinService {
  private configSource = new Subject<MapPinConfig | null>();
  private resultSource = new Subject<MapPinResult | null>();

  config$: Observable<MapPinConfig | null> = this.configSource.asObservable();
  result$: Observable<MapPinResult | null> = this.resultSource.asObservable();

  /** Called by parent to open the modal with initial coordinates */
  configure(config: MapPinConfig): void {
    this.configSource.next(config);
  }

  /** Called by modal on Save — emits result and closes */
  confirm(result: MapPinResult): void {
    this.resultSource.next(result);
    this.configSource.next(null);
  }

  /** Called when T2Card is closed externally (X button) — only cleans up map */
  dismiss(): void {
    this.configSource.next(null);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/map-pin-adjustment/map-pin.service.ts